// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ej-a";
export var fulfillmentFormRail = "_ej-9";
export var headerTitleRow = "_ej-c";
export var orderDetailsWrapper = "_ej-7";
export var orderLinkTrigger = "_ej-2";
export var paymentInformationGrid = "_ej-h";
export var paymentSummaryColumn = "_ej-i";
export var shipmentContainer = "_ej-b";
export var shipmentDetailsMainPane = "_ej-8";
export var shipmentNavigationCard = "_ej-5";
export var shipmentNavigationRail = "_ej-3";
export var shipmentNavigationRailHeader = "_ej-4";
export var shipmentSummaryFact = "_ej-e";
export var shipmentSummaryGrid = "_ej-d";
export var shipmentSummaryMetadataRow = "_ej-f";
export var shipmentSummaryTags = "_ej-g";
export var shipmentWorkspace = "_ej-0";
export var shipmentWorkspaceContent = "_ej-6";
export var shipmentWorkspaceHeader = "_ej-1";